/* ============================================
   Section: home-man-women-collections
   Dynamic tab switching (supports 1–4 tabs)
   ============================================ */

(function () {
  function initSection(section) {
    if (!section || section.dataset.initialized) return;
    section.dataset.initialized = 'true';

    var tabs = section.querySelectorAll('[data-tab-trigger]');
    var cards = section.querySelectorAll('[data-tab]');
    var defaultTab = section.dataset.defaultTab || 'tab_1';

    if (!tabs.length || !cards.length) return;

    function switchTab(tabId) {
      /* Update tab buttons */
      tabs.forEach(function (tab) {
        var isActive = tab.getAttribute('data-tab-trigger') === tabId;
        if (isActive) {
          tab.classList.add('section-home-man-women-collections__tab--active');
        } else {
          tab.classList.remove('section-home-man-women-collections__tab--active');
        }
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      /* Show / hide cards */
      cards.forEach(function (card) {
        if (card.getAttribute('data-tab') === tabId) {
          card.classList.remove('section-home-man-women-collections__card--hidden');
          card.style.display = '';
        } else {
          card.classList.add('section-home-man-women-collections__card--hidden');
          card.style.display = 'none';
        }
      });
    }

    /* Bind click events */
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        switchTab(this.getAttribute('data-tab-trigger'));
      });
    });

    /* Set initial state from the Liquid-computed default */
    switchTab(defaultTab);

    /* Theme editor: switch tab when a hidden block is selected */
    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      document.addEventListener('shopify:block:select', function (event) {
        var card = event.target.closest('[data-tab]');
        if (card && section.contains(card)) {
          switchTab(card.getAttribute('data-tab'));
        }
      });
    }
  }

  function initAll() {
    var sections = document.querySelectorAll('.section-home-man-women-collections');
    for (var i = 0; i < sections.length; i++) {
      initSection(sections[i]);
    }
  }

  /* Handle normal page load */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Handle Shopify theme editor section reload */
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.section-home-man-women-collections');
    if (section) {
      section.removeAttribute('data-initialized');
      initSection(section);
    }
  });
})();
